import { createContext, useContext } from "react";

export const RegistrarWorkspaceFrameContext = createContext(false);

/** Keeps the frame's workspace identity as the sole page h1. */
export function useRegistrarWorkspaceFrame() {
  return useContext(RegistrarWorkspaceFrameContext);
}
